<template>
  <div>
    <v-expansion-panels class="mb-4">
      <v-expansion-panel
        style="border-bottom: thin solid rgba(0, 0, 0, 0.12) !important;"
      >
        <v-expansion-panel-header id="support-filter-header"
        >Tìm kiếm yêu cầu</v-expansion-panel-header
        >
        <v-expansion-panel-content>
          <v-list-item three-line class="overflow-visible pa-0">
            <v-list-item-content class="overflow-visible pa-0">
              <validation-observer v-slot="{ handleSubmit }">
                <v-row>
                  <v-col cols="12" md="4" sm="12">
                    <common-range-picker
                      :clearable="true"
                      :aLight="'right'"
                      label="Ngày tạo"
                      v-model="filterForm.dateRange"
                      :defaultRange="defaultRange"
                    />
                  </v-col>
                  <v-col cols="12" md="4" sm="12">
                    <v-autocomplete
                      v-model="filterForm.groupTicketName"
                      attach
                      :items="groupTickes"
                      label="Nhóm ticket"
                      color="primary"
                      placeholder="Chọn nhóm ticket..."
                      item-text="groupTicketName"
                      item-value="groupTicketName"
                      clearable
                    >
                    </v-autocomplete>
                  </v-col>
                  <v-col cols="12" md="4" sm="12">
                    <v-autocomplete
                      :key="reRender"
                      v-model="filterForm.typeTicketName"
                      attach
                      :items="ticketTypeNames"
                      label="Loại ticket"
                      color="primary"
                      placeholder="Chọn loại ticket..."
                      item-text="typeTicketName"
                      item-value="typeTicketName"
                      clearable
                    >
                    </v-autocomplete>
                  </v-col>
                  <v-col cols="12" sm="4">
                    <v-text-field
                      v-model="filterForm.studentId"
                      label="Mã học sinh"
                      placeholder="Nhập mã học sinh..."
                      clearable
                    />
                  </v-col>
                  <v-col cols="12" sm="4">
                    <v-select
                      label="Hiển thị"
                      :items="viewTypeOptions"
                      v-model="filterForm.viewType"
                    >
                    </v-select>
                  </v-col>
                  <v-col cols="12" md="4" sm="12">
                    <v-autocomplete
                      v-model="filterForm.status"
                      attach
                      :items="listTicketStatus"
                      label="Trạng thái"
                      color="primary"
                      placeholder="Chọn trạng thái..."
                      item-text="value"
                      item-value="id"
                      clearable
                    >
                    </v-autocomplete>
                  </v-col>
                  <v-col cols="12" md="4" sm="12">
                    <v-autocomplete
                      v-model="filterForm.gradeName"
                      attach
                      multiple
                      :items="listGradeName"
                      label="Lớp"
                      color="primary"
                      placeholder="Chọn lớp..."
                      item-text="text"
                      item-value="text"
                      clearable
                    >
                    </v-autocomplete>
                  </v-col>
                  <v-col cols="12" md="4" sm="12">
                    <v-autocomplete
                      v-model="filterForm.subjectName"
                      attach
                      :items="listSubjectName"
                      label="Môn học"
                      color="primary"
                      placeholder="Chọn môn học..."
                      item-text="name"
                      item-value="name"
                      clearable
                      @change="handleChangeLevel()"
                    >
                    </v-autocomplete>
                  </v-col>
                  <v-col cols="12" md="4" sm="12">
                    <v-menu
                      :disabled="!filterForm.subjectName"
                      bottom
                      offset-y
                      content-class="menu-wrapper-tree-user"
                      :close-on-content-click="false">
                      <template v-slot:activator="{ on, attrs }">
                        <div
                          v-if="filterForm.level && filterForm.level.length === 0"
                          v-bind="attrs"
                          v-on="on">
                          <v-select
                            label="Trình độ"
                            color="primary"
                            placeholder="Chọn trình độ..."
                            readonly
                            hide-details
                            dense
                            style="margin-top: 22px"
                            :disabled="!filterForm.subjectName"
                          >
                          </v-select>
                        </div>
                        <div v-bind="attrs" v-on="on" v-else style="position: relative">
                          <div class="mt-1 tree-user-selected">
                              <span
                                v-for="(node, index) in filterForm.level"
                                :key="node + index"
                              >
                                <v-chip color="#F8E5FF" close close-icon="mdi-close" @click:close="removeItemLevel(index)">
                                  {{ handleCutChipText(node, 30) }}
                                </v-chip>
                              </span>
                          </div>
                          <v-icon
                            class="icon-clear-all"
                            color="grey"
                            @click="removeFilterFormLevel()">mdi-trash-can-outline
                          </v-icon>
                        </div>
                      </template>
                      <template>
                        <div style="background: white; max-height: 400px; overflow: auto; padding: 0 12px">
                          <v-treeview
                            v-if="computedLevelTreeItem && computedLevelTreeItem.length > 0"
                            v-model="filterForm.level"
                            selectable
                            :items="computedLevelTreeItem"
                            item-text="name"
                            item-key="fakeName"
                          ></v-treeview>
                          <div v-else style="padding: 12px">
                            Không có dữ liệu
                          </div>
                        </div>
                      </template>
                    </v-menu>
                  </v-col>
                  <v-col cols="12" md="4" sm="12">
                    <v-text-field
                      v-model="filterForm.nameCode"
                      :disabled="!filterForm.viewType"
                      label="Người tạo"
                      placeholder="Nhập người tạo..."
                      clearable
                    />
                  </v-col>
                </v-row>
                <div class="text-center mb-4">
                  <v-btn class="primary mx-0" @click="handleSubmit(searchList)">
                    <v-icon>mdi-magnify</v-icon>Tìm kiếm
                  </v-btn>
                </div>
              </validation-observer>
            </v-list-item-content>
          </v-list-item>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </div>
</template>
<script>
import mapSubject from '@/mixins/mapSubject';
import { LIST_STATUS_SUPPORT } from '@/modules/ticket/const';
import { regex } from '@/helpers/constant';
import SupportRepository from '@/services/SupportRepository';
import { mapState } from 'vuex';
import levelSublevel from '@/mixins/levelSublevel';
import { CARE_DUO_CLASSES } from '../../duo_care/constant';

export default {
  components: { },
  mixins: [mapSubject, levelSublevel],
  props: {
    isMobile: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      testField: '',
      defaultRange: {
        // startDate: moment()
        //   .startOf("isoWeek")
        //   .format("YYYY-MM-DD"),
        // endDate: moment()
        //   .endOf("isoWeek")
        //   .format("YYYY-MM-DD"),
      },
      viewTypeOptions: [
        {
          text: 'Chỉ ticket của tôi',
          value: 0,
        },
        {
          text: 'Tất cả ticket',
          value: 1,
        },
      ],
      reRender: 0,
      ticketTypeNames: [],
      groupTickes: [],
      regex,
      filterForm: {
        // startDateTime: moment()
        //   .startOf('isoWeek')
        //   .format('YYYY-MM-DD'),
        // endDateTime: moment()
        //   .endOf('isoWeek')
        //   .format('YYYY-MM-DD'),
        dateRange: [],
        groupTicketName: null,
        typeTicketName: null,
        subjectName: null,
        level: [],
        gradeName: null,
        viewType: 0,
        nameCode: '',
      },
      menuStart: false,
      menuEnd: false,
      listStatusSupport: LIST_STATUS_SUPPORT,
      groupTickesClone: [],
      ticketTypeQuerry: null,
      listGradeName: CARE_DUO_CLASSES,
      listLevel: [],
      listSubjectName: [{ id: 1, name: 'Toán' }, { id: 15, name: 'Ngữ Văn' }, { id: 5, name: 'Tiếng Anh' }],
    };
  },
  computed: {
    ...mapState('ticket', ['listTicketStatus']),
    computedLevelTreeItem() {
      let result = [];
      if (this.filterForm.subjectName && this.filterForm.subjectName !== this.getSubjectById(15).name) {
        result = this.filterForm.subjectName === this.getSubjectById(5).name ? JSON.parse(JSON.stringify(this.levelEnglish)) : JSON.parse(JSON.stringify(this.levelDefault));
        result.forEach((e) => {
          if (e.children) {
            e.fakeName = `${e.name}node`;
            e.children.forEach((child) => {
              if (child.id === -1) {
                // eslint-disable-next-line no-param-reassign
                child.fakeName = e.name.toUpperCase();
              } else {
                // eslint-disable-next-line no-param-reassign
                child.fakeName = e.name.toUpperCase() + child.name;
              }
            });
          } else {
            e.fakeName = e.name.toUpperCase();
          }
        });
      }
      return result;
    },
  },
  watch: {
    'filterForm.groupTicketName': function (name) {
      this.filterForm.typeTicketName = null;
      if (this.ticketTypeQuerry && !this.reRender) {
        this.filterForm.typeTicketName = this.ticketTypeQuerry;
      }
      this.ticketTypeNames = [];
      // eslint-disable-next-line no-plusplus
      this.reRender++;
      if (!name) {
        this.ticketTypeNames = [];
        return;
      }
      this.groupTickesClone.forEach((e) => {
        if (e.groupTicketName === name && e.typeTicketName !== null) {
          this.ticketTypeNames.push(e);
        }
      });
      // this.ticketTypeNames = this.groupTickesClone.filter(
      //   (item) => item.name === name,
      // )[0].TicketGroupType;
    },
  },
  async created() {
    await this.getGroupTickets();
    this.filterForm.customerCode = this.$route.query?.nameCode;
    this.filterForm.createdName = this.$route.query?.createdName;
    // this.defaultRange = {
    //   startDate: this.$route.query?.createdAt
    //     ? moment(this.$route.query?.createdAt).format('YYYY-MM-DD')
    //     : null,
    //   endDate: this.$route.query?.createdAt
    //     ? moment(this.$route.query?.createdAt).format('YYYY-MM-DD')
    //     : null,
    // };
    // if (this.$route.query?.createdAt) {
    //   this.filterForm.activatedAt = [moment(this.$route.query?.createdAt).format('YYYY-MM-DD'), moment(this.$route.query?.createdAt).format('YYYY-MM-DD')];
    // }
  },
  methods: {
    handleCutChipText(text, number = 20) {
      return text.length > number ? `${text.slice(0, number - 2)}...` : text;
    },
    removeFilterFormLevel() {
      this.filterForm.level = [];
    },
    removeItemLevel(index) {
      this.filterForm.level.splice(index, 1);
    },
    handleChangeLevel() {
      setTimeout(() => {
        this.removeFilterFormLevel();
      }, 200);
    },
    async getLevelTicket(subjectId) {
      const res = await SupportRepository.getLevelTicketApi(subjectId);
      if (res.success) {
        this.listLevel = _.get(res, 'data', []);
      }
    },
    async getGroupTickets() {
      const params = {
        'filters[$eq__systemId]': 3,
      };
      const res = await SupportRepository.getGroupTickets(params);
      if (res.success) {
        this.groupTickes = _.get(res, 'data', []);
        this.groupTickesClone = _.cloneDeep(this.groupTickes);
      }
    },
    searchList() {
      // let element = document.getElementById("support-filter-header");
      // if (element) {
      //   element.click();
      // }
      const formData = {
        ...this.filterForm,
      };
      Bus.$emit('search-request-support-list-2', formData);
    },
  },
};
</script>

<style lang="scss">
button#support-filter-header {
  font-weight: 900;
  color: #777;
  display: flex;
  flex-direction: row-reverse;
  justify-content: left;
  align-content: center;
  .v-expansion-panel-header__icon {
    margin-left: 0 !important;
    border: 1px solid #a9a9a9;
    margin-right: 10px;
    border-radius: 5px;
  }
}
.tree-user-selected {
  min-height: 34px;
  overflow-y: auto;
  border-bottom: 1px solid #d2d2d2;
  display: flex;
  flex-wrap: wrap;
  row-gap: 4px;
  column-gap: 4px;
  padding: 8px 40px 4px 8px;
}
.icon-clear-all {
  position: absolute !important;
  right: 15px;
  top: 13px;
  /*background: white;*/
}
</style>
